// Auto-generated translation for en.
// Source: landings.js, translated via Claude Sonnet on 2026-05-26T11:01:54.636039+00:00.

export const LANDINGS = {
  "eigen-paard": {
    slug: "eigen-paard",
    eyebrow: "For horse owners",
    title: "Everything for your horse. In one app.",
    subtitle: "Manage health, training, planning and professionals from one clear, comprehensive record.",
    primaryCTA: {
      label: "Start for free",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "View Premium",
      href: "/premium",
    },
    heroScreenshot: {
      url: "/assets/owner-horse.png",
      alt: "Horse profile — weight, vaccination, EquiCoach, nutrition and training in one screen",
      caption: "Your horse, completely in view.",
    },
    problem: "Right now you're probably keeping appointments, photos, training, nutrition and health scattered across WhatsApp groups, shoeboxes and separate apps. That means you lose overview.",
    solution: "EquiSight turns your horse into one complete digital record that travels with you.",
    benefits: [
      "One complete horse profile per horse",
      "Health, farrier, dentist and physio all in one place",
      "Calendar with smart reminders",
      "Photos, notes and history without limits",
      "Backup of all your data with Premium",
    ],
    pricing: {
      tiers: [
        {
          name: "Basic",
          price: "€0",
          note: "1 horse · always free",
        },
        {
          name: "Premium",
          price: "€4,99",
          note: "Multiple horses + backup",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Ready to get started?",
      title: "Begin today with your first horse.",
      href: "/#waitlist",
    },
  },
  "premium": {
    slug: "premium",
    eyebrow: "Premium",
    title: "More horses. More overview. More certainty.",
    subtitle: "Upgrade to Premium and manage all your horses without limits — with full EquiCoach intelligence.",
    primaryCTA: {
      label: "Start 14 days free",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "All prices",
      href: "/#pricing",
    },
    audience: "For owners, sport riders and horse keepers with multiple horses.",
    features: [
      "Add unlimited horses",
      "Complete history per horse",
      "Data backup",
      "Advanced EquiCoach insights",
      "Smart notifications and planning",
      "Health and training fully connected",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Less than €0.17 per day",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Ready?",
      title: "Upgrade to Premium.",
      href: "/#waitlist",
    },
  },
  "manege-ruiter": {
    slug: "manege-ruiter",
    eyebrow: "For arena riders",
    title: "Improve your riding, even without your own horse.",
    subtitle: "Track your lessons, training sessions, and progress within EquiSight — for less than a cup of coffee per month for mum or dad. Or a delicious ice cream with whipped cream.",
    primaryCTA: {
      label: "Start with Premium",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "How does it work?",
      href: "#features",
    },
    problem: "As an arena rider you often don't have a horse of your own, but you still want to grow and keep track of your lessons, goals, and the horses you ride.",
    solution: "Arena rider functionality is included as standard in Premium — follow your own development and view the linked school horses in read-only mode.",
    features: [
      "Track training sessions",
      "Set goals",
      "Monitor progress",
      "View school horses with name and photo",
      "No access to private health data",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Per month · arena rider functionality included",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Become a member",
      title: "Get started as an arena rider.",
      href: "/#waitlist",
    },
  },
  "manege-module": {
    slug: "manege-module",
    eyebrow: "For riding schools & stables",
    title: "Make your riding school digitally accessible to every rider.",
    subtitle: "Give riders a connection to horses, lessons, and progress — without sharing sensitive stable data.",
    primaryCTA: {
      label: "Request access",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "View modules",
      href: "#features",
    },
    audience: "EquiSight helps riding schools and stables keep riders engaged for longer and stand out digitally.",
    features: [
      "Make stable horses visible to riders",
      "Name and photo per horse",
      "Link riders to horses",
      "Read-only access for privacy-sensitive data",
      "Lesson and training history in one place",
      "User management with roles",
    ],
    benefits: [
      "Stronger connection with riders",
      "More professional appearance",
      "Extra digital service for members",
      "New revenue stream through app usage",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Per month · riding school functionality included for riders",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Ready?",
      title: "Activate the Riding School Module.",
      href: "/#waitlist",
    },
  },
  "fokkerij": {
    slug: "fokkerij",
    eyebrow: "Breeding module",
    title: "Stay in control of cycles, gestation, and foal development.",
    subtitle: "The complete breeding module for mare owners and breeders — from covering to foal, in one timeline.",
    primaryCTA: {
      label: "Activate Breeding Module",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "View features",
      href: "#features",
    },
    audience: "For breeders, mare owners, and stables managing multiple mares.",
    features: [
      "Cycle tracking",
      "Record heat cycles",
      "Log insemination dates",
      "Countdown to ultrasounds",
      "Schedule pregnancy checks",
      "Pedigree and lineage",
      "Foal development",
      "Overview of all pregnant mares",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Per month · Breeding module included in Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Start today",
      title: "Get started with breeding management.",
      href: "/#waitlist",
    },
  },
  "hoefsmid": {
    slug: "hoefsmid",
    eyebrow: "Farrier module",
    title: "Work smarter as a farrier. Record everything professionally.",
    subtitle: "Schedule, photos, notes and treatment history in one module — less miscommunication, stronger records.",
    primaryCTA: {
      label: "Get started as a farrier",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "View Professional Bundle",
      href: "/professional",
    },
    audience: "For farriers who want to improve overview, documentation and client communication.",
    features: [
      "Personal schedule",
      "Appointments per client",
      "View horse profiles",
      "Add before and after photos",
      "Record treatment",
      "Log advice and notes",
      "ETA notification to client: \"The farrier is on the way\"",
    ],
    benefits: [
      "Work more professionally",
      "Less miscommunication",
      "Better record keeping",
      "Stronger in liability situations",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Per month · Farrier module included in Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Ready?",
      title: "Activate Farrier Module.",
      href: "/#waitlist",
    },
  },
  "paardentandarts": {
    slug: "paardentandarts",
    eyebrow: "Dentistry module",
    title: "A complete dental record for every horse.",
    subtitle: "Log findings, treatments and follow-ups directly in EquiSight.",
    primaryCTA: {
      label: "Get started as an equine dentist",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "View Professional Bundle",
      href: "/professional",
    },
    audience: "Equine dentists, veterinarians and practices that want to work in a structured way.",
    features: [
      "Record dental check-ups",
      "Findings per treatment",
      "Add photos",
      "Report to owner",
      "Follow-up advice",
      "History per horse",
      "Schedule new appointment",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Per month · Dentistry module included in Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Ready?",
      title: "Activate Dentistry Module.",
      href: "/#waitlist",
    },
  },
  "fysio-osteo": {
    slug: "fysio-osteo",
    eyebrow: "Physio / Osteo Module",
    title: "Track body, movement and recovery professionally.",
    subtitle: "For physiotherapists and osteopaths who want to structurally support horses.",
    primaryCTA: {
      label: "Start as physio/osteo",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "View Professional Bundle",
      href: "/professional",
    },
    features: [
      "Intake per horse",
      "Record body findings",
      "Add photos and videos",
      "Create treatment report",
      "Share exercises and follow-up",
      "Track recovery journey",
      "History per horse",
    ],
    benefits: [
      "Better insight over time",
      "Professional reporting",
      "Clear communication with owner, trainer and rider",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Per month · Physio / Osteo module included in Professional",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Ready?",
      title: "Activate Physio / Osteo Module.",
      href: "/#waitlist",
    },
  },
  "trainer": {
    slug: "trainer",
    eyebrow: "Trainer module",
    title: "Coach riders with data, goals, and progress.",
    subtitle: "Make training measurable and guidance more professional — for one or multiple riders.",
    primaryCTA: {
      label: "Get started as a trainer",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "View Pro package",
      href: "/#pricing",
    },
    audience: "For instructors, trainers, and coaches with multiple riders or horses.",
    features: [
      "Link riders",
      "Track horses",
      "Set training goals",
      "Provide feedback",
      "Analyse competition results",
      "View progress per combination",
      "Use protocol analyses for training focus",
    ],
    benefits: [
      "Better guidance",
      "More structure",
      "More professional communication",
      "Stronger client relationships",
    ],
    pricing: {
      tiers: [
        {
          name: "Pro",
          price: "€14,99",
          note: "Per month · Trainer module included in Pro",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Ready?",
      title: "Activate Trainer Module.",
      href: "/#waitlist",
    },
  },
  "wedstrijdanalyse": {
    slug: "wedstrijdanalyse",
    eyebrow: "Competition Analysis",
    title: "From scoresheet to performance improvement.",
    subtitle: "Upload your competition scoresheet and discover where you're leaving points on the table — not just viewing your score, but understanding how to improve.",
    primaryCTA: {
      label: "Analyse your first scoresheet",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "View Premium",
      href: "/premium",
    },
    features: [
      "Upload scoresheet photo",
      "Process front and back side",
      "Recognise class, test number and judge",
      "Analyse scores per movement",
      "Summarise comments",
      "Show strengths and weaknesses",
      "Trends per horse-rider combination",
    ],
    pricing: {
      tiers: [
        {
          name: "Premium",
          price: "€4,99",
          note: "Per month · competition analysis included from Premium",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Ready?",
      title: "Get started with competition analysis.",
      href: "/#waitlist",
    },
  },
  "professional": {
    slug: "professional",
    eyebrow: "Professional Bundle",
    title: "For professionals working with horses.",
    subtitle: "Farrier, dentist, physio, osteo or trainer: collaborate within one digital horse record.",
    primaryCTA: {
      label: "Get started as a professional",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "View individual modules",
      href: "#features",
    },
    audience: "The Professional Bundle combines all specialist modules in one subscription.",
    features: [
      "Farrier Module",
      "Dentist Module",
      "Physio / Osteo Module",
      "Agenda & client management",
      "Horse profiles & reports",
      "Treatment history & record building",
      "Communication with owner",
    ],
    pricing: {
      tiers: [
        {
          name: "Professional",
          price: "€24,99",
          note: "Per month · all specialist modules included",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Ready?",
      title: "Choose Professional.",
      href: "/#waitlist",
    },
  },
  "noodnummerpaard": {
    slug: "noodnummerpaard",
    eyebrow: "Emergency numbers horse",
    title: "Always the right help within reach.",
    subtitle: "In an emergency, every second counts. With EquiSight, all the important contact details for your horse are instantly available — one tap and you're calling.",
    primaryCTA: {
      label: "Set up your emergency contacts",
      href: "/#waitlist",
    },
    secondaryCTA: {
      label: "Start free with EquiSight",
      href: "/#waitlist",
    },
    accent: "danger",
    heroScreenshot: {
      url: "/assets/emergency.png",
      alt: "Emergency contacts — call, WhatsApp or navigate directly to your vet, clinic and farrier",
      caption: "One tap. No panicked searching.",
      embeddedFrame: true,
    },
    problem: "Your horse has something — colic, injury, distress. And then the searching begins. Who do you call? Do you have the right number? Is this the emergency number? Precious time is lost.",
    solution: "With EquiSight, everything is right at your fingertips. No searching. No doubt. One tap and you're in contact.",
    scenario: {
      title: "Imagine — your horse is showing signs of colic.",
      steps: [
        "You open EquiSight",
        "Tap \"Vet\"",
        "Call directly",
      ],
      tagline: "No stress. No searching. Just action.",
    },
    features: [
      "All emergency numbers in one place",
      "One-tap calling from within the app",
      "WhatsApp with one tap",
      "Navigate directly to the address",
      "Each horse has its own contact list",
      "Vet, clinic, farrier, dentist, physio",
      "Address + directions instantly available",
      "Mark favourite numbers with a star",
      "Emergency numbers (112, 144) always at the top",
    ],
    benefits: [
      "Calm and control in an emergency",
      "Everyone at the yard has the same numbers ready",
      "No more forgotten business cards",
      "Respond seconds faster in urgent situations",
    ],
    audience: "For horse owners, caretakers, trainers and yards — everyone who is responsible for a horse.",
    showcase: {
      eyebrow: "Pre-configured for you",
      title: "13 categories of contacts — ready to fill in.",
      description: "From vet and emergency clinic to saddler, instructor and pasture manager. EquiSight knows your world and sets up the right contact fields for you in advance. Tap, fill in, done.",
      bullets: [
        "Emergency & health — vet, emergency, clinic, poison control line",
        "Daily care — farrier, dentist, physio, instructor",
        "Yard & pasture — yard manager, pasture manager, livery stable",
        "Feed & supplies — hay, concentrates, straw suppliers",
      ],
      image: {
        url: "/assets/emergency-manage.png",
        alt: "Emergency contacts management screen — all suggested contacts per category",
        embeddedFrame: true,
      },
    },
    checklist: {
      title: "Emergency numbers checklist for your horse",
      items: [
        "Vet",
        "Emergency clinic (24/7)",
        "Animal ambulance · 144",
        "Farrier",
        "Backup contact person",
        "General emergency number · 112",
      ],
      cta: {
        label: "Open in EquiSight and fill in right away",
        href: "/#waitlist",
      },
    },
    pricing: {
      tiers: [
        {
          name: "Emergency numbers",
          price: "Gratis",
          note: "Always free · for everyone, on every plan",
          highlight: true,
        },
      ],
    },
    finalCTA: {
      eyebrow: "Make sure you're prepared",
      title: "Before you need it.",
      href: "/#waitlist",
    },
    microcopy: [
      "No obligations",
      "Set up within 2 minutes",
      "Always adjustable",
    ],
  },
};

export default LANDINGS;
